export const environment = {
  displayApiErrorDetail: true,
  production: false,
  appVersion: `1.0.0-dev`,
  // Temporary: the dev APIM instance is qcr-apim-dev2-enterprise while the usual name is reserved to the old
  // dev tenant. Revert the commits that added this to go back to qcr-apim-dev-enterprise.
  apiBaseUrl: `https://qcr-apim-dev2-enterprise.azure-api.net/qcr/v1`,
  authenticationAudience: `d1a0dda6-6e94-471e-b11c-7a8b73f2c3ad`,
  authenticationAuthority: `https://login.microsoftonline.com/6ba304a6-520a-4cdd-afbe-5a41919ed38a`,
  authenticationAuthorityDomain: '',
  applicationInsightsKey: `b3804e2e-4b77-4093-b9ae-625f7bb70aca`,
  authorizationBaseUrl: '',
  authorizationScope: `api://25609102-55a2-4fe4-afff-c2cc1fc94398/QCR.API.ReadWrite`,
  accessTokenEndpoint: '',
  logOutEndpoint: '',
  redirectUri: `https://web-qcr-dev2.nzqa.govt.nz`
};
